export const PHONE_MEDIA_QUERY = '(max-width: 640px)';
export const IS_IE11 = (typeof window !== 'undefined' && !!window.MSInputMethodContext && !!document.documentMode);
export const IS_ON_PHONE = (typeof window !== 'undefined' && window.matchMedia)
  ? window.matchMedia(PHONE_MEDIA_QUERY).matches
  : false;
